let incrementingId = 0;
export const createStreamingResponseMessage = (source, message, threadId) => {
  if (message) {
    return Object.assign({}, message, {
      streamingState: 'streaming'
    });
  } else {
    return {
      actions: [],
      displayType: 'LOADING',
      id: incrementingId++,
      query: {
        intent: 'unknown'
      },
      source,
      status: 'loading',
      response: 'loading',
      value: 'loading',
      time: Date.now(),
      thread_id: threadId,
      type: 'loading'
    };
  }
};